import { toast } from "sonner";
import * as z from "zod/v4";
import {
  setSessionStorageValue,
  takeSessionStorageValue,
} from "@/lib/hooks/sessionStorage";

const FLASH_KEY = "flash-message";

const flashSchema = z.object({
  type: z.enum(["success", "error"]),
  text: z.string().min(1),
});

type FlashMessage = z.infer<typeof flashSchema>;

/**
 * Queues a toast for after the next render instead of firing it now.
 *
 * Route loaders run before React mounts, and sonner delivers a toast only to
 * subscribers registered at publish time — the Toaster subscribes in an effect,
 * so anything a loader toasts on a full page load is dropped.
 */
export function setFlashMessage(message: FlashMessage) {
  setSessionStorageValue(FLASH_KEY, message, flashSchema);
}

export function showPendingFlashMessage() {
  const message = takeSessionStorageValue(FLASH_KEY, flashSchema);
  if (message) toast[message.type](message.text);
}
